import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

const StatCounter = ({ value, prefix = "", suffix = "", label }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <div ref={ref} data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-center">
      <div className="font-display text-5xl text-gold lg:text-6xl">
        {prefix}
        {display.toLocaleString("it-IT")}
        {suffix}
      </div>
      <div className="mt-3 text-xs font-semibold uppercase tracking-[0.25em] text-white/50">{label}</div>
    </div>
  );
};

export default StatCounter;
